import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, PershingTranslationService, DomainContext } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { BlanceKeyRestService } from '../../services/NXI-Balances.services';

declare let dojoApp: any;
@Component({
    selector: 'balances-disclaimers',
    templateUrl: './balances-disclaimers.component.html'
})
export class BalancesdisclaimersComponent implements OnInit, OnDestroy {
    realTimeActive: boolean = false;
    inputValue: string = '';
    domain: string = '';
    subs: Subscription[] = [];
    subs1: Subscription;
    hasCurrencyDataToDisplay: boolean = false;
    acctRef: any;
    balancesDisclaimersParams: any;
    marginEnabled: boolean;
    entitledForLiabilities: boolean;
    foreignCurrencyDisplay: boolean;
    group: boolean;
    isMobile: boolean = false;
    isAdaTheme: boolean = false;
    // Custodian view if it's account is a custodian or account group (including the 'ALL') contains 1 custodian.
    custodianView: boolean = false;
    isTRP: boolean = false;
    loanAdvdata: any;
    liabilitiesData: any;

    constructor(
        private contextService: IContextService, private nxiWidgetParamsService: NxiWidgetParamsService,
        private translationService: PershingTranslationService, private route: ActivatedRoute,
        private nxiRestService: NxiRestService,
        private balanceRestService: BlanceKeyRestService, @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.isMobile = appSettings.deviceType && appSettings.deviceType === 'mobile';
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
        }
        if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === '30A') {
            this.isTRP = true;
        }
    }
    ngOnInit() {
        this.subs[this.subs.length] = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            // this.domain = domainContext.domain ? domainContext.domain : CoreConstants.ACCOUNT;
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;

            this.getDisclaimersData();
           // this.getLoanAdvance();
           this.getUserLiabilities();
        });

        this.subs[this.subs.length] = this.route.queryParams.subscribe(params => {
            if (params.rt) {
                this.realTimeActive = (params.rt === 'true');
            }
        });
        // Disclaimer supper script logic counts (literally query supBalancesClass) and so to avoid miscount,
        // DOM must be created and contains either supBalancesClass if currency displayed or not at all otherwise.
        this.subs[this.subs.length] = this.balanceRestService.balancesResponse$.subscribe(response => {
            this.hasCurrencyDataToDisplay = response && !response.groupBalance && response.currencyDetail &&
                response.currencyDetail.length > 0 && response.currencyDetail.some((c: any) => { return c.detailType === 'T'; }) &&
                response.currencyDetail.some((c: any) => { return c.detailType === 'S'; });
        });

    }

    ngOnDestroy(): void {
        if (this.subs && this.subs.length > 0) {
            for (let i = 0; i < this.subs.length; i++) {
                this.subs[i].unsubscribe();
            }
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyBalancesdisclaimers();
        }
    }
    getDisclaimersData() {
        if (sessionStorage.getItem('realTimeActive') && 'true' === sessionStorage.getItem('realTimeActive')) {
            this.realTimeActive = true;
        } else {
            this.realTimeActive = false;
        }
        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'balanceDisclaimers?rt=' + this.realTimeActive).subscribe(
            resp => {
                if (resp.response) {
                    const b = <HTMLElement>document.querySelector('#balances_disclaimer');
                    b.style.display = '';
                    this.balancesDisclaimersParams = resp.response;
                    this.marginEnabled = resp.response.marginEnabled;
                    this.entitledForLiabilities = resp.response.entitledForLiabilities;
                    this.foreignCurrencyDisplay = resp.response.foreignCurrencyDisplay;
                    this.group = resp.response.group;
                    this.realTimeActive = resp.response.realTimeActive;
                    this.custodianView = resp.response.bankCustodyAccount;
                    this.renderDojoWidget();
                }
            }
        );
    }
    getUserLiabilities() {
        this.balanceRestService.getLiabilities().subscribe(resp => {
            this.liabilitiesData = resp;
            if (!!this.liabilitiesData) {
                if (this.liabilitiesData.returnCode === 'SUCCESS') {
                    let element = document.getElementById('liabilitiesDisclaimer1');
                        console.log('element ' + element);
                        if (element) {
                            if(this.isAdaTheme) {
                                element.classList.remove('dijitDisplayNone');
                            }
                        }
                }
            }
        });
    }
    renderDojoWidget() {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderBalancesdisclaimers(this.inputValue);
        }
    }
}
